import { Reducer } from 'redux';
import { set, flow } from 'lodash/fp';

import { Role, RolesActionTypes, RolesState } from './types';
import { LoginActionTypes } from '../../../auth/login/store/types';

export const initialRole: Role = {
    roleName: '',
    roleDescription: '',
    featurePermissions: [],
    accessGroupIds: [],
    userIds: []
};

export const INITIAL_STATE: RolesState = {
    allRoles: [],
    selectedRole: initialRole,
    savedSelectedRole: initialRole,
    fetchingRoles: false,
    rolesError: '',
    roleModalOpen: false,
    deleteConfirmationDialogOpen: false,
    deletingRole: false
};

export const rolesReducer: Reducer<RolesState> = (state = INITIAL_STATE, { type, payload }): RolesState => {
    switch (type) {
        case RolesActionTypes.TOGGLE_ROLES_MODAL: {
            const { role, isOpen } = payload;
            const selectedRole = role || initialRole;
            return flow(
                set('roleModalOpen', isOpen),
                set('selectedRole', selectedRole),
                set('savedSelectedRole', selectedRole)
            )(state);
        }
        case RolesActionTypes.UPDATE_ROLE_VALUE: {
            const { key, value } = payload;
            return set(`selectedRole[${key}]`, value, state);
        }
        case RolesActionTypes.UPSERT_ROLE_FAILED:
            return set('rolesError', payload, state);
        case RolesActionTypes.UPSERT_ROLE_SUCCESSFUL:
            return flow(
                set('roleModalOpen', false),
                set('selectedRole', initialRole),
                set('savedSelectedRole', initialRole),
                set('allRoles', payload)
            )(state);
        case RolesActionTypes.FETCH_ALL_ROLES_STARTED:
            return set('fetchingRoles', true, state);
        case RolesActionTypes.FETCH_ALL_ROLES_SUCCESSFUL: {
            return flow(
                set('allRoles', payload),
                set('fetchingRoles', false)
            )(state);
        }
        case RolesActionTypes.FETCH_ALL_ROLES_FAILED:
            return flow(
                set('rolesError', payload),
                set('fetchingRoles', false)
            )(state);
        case RolesActionTypes.TOGGLE_DELETE_ROLE_CONFIRMATION_MODAL: {
            const { isOpen, role } = payload;
            const selectedRole = role || initialRole;
            return flow(
                set('deleteConfirmationDialogOpen', isOpen),
                set('selectedRole', selectedRole)
            )(state);
        }
        case RolesActionTypes.DELETE_ROLE_STARTED:
            return set('deletingRole', true, state);
        case RolesActionTypes.DELETE_ROLE_SUCCESSFUL:
            return flow(
                set('allRoles', payload),
                set('deletingRole', false),
                set('deleteConfirmationDialogOpen', false)
            )(state);
        case RolesActionTypes.DELETE_ROLE_FAILED:
            return flow(
                set('rolesError', payload),
                set('deletingRole', false)
            )(state);
        case RolesActionTypes.DUPLICATE_ROLE: {
            const { roleDescription, featurePermissions, accessGroupIds, userIds } = payload;
            const duplicate: Role = { roleName: '', roleDescription, featurePermissions, accessGroupIds, userIds };
            return flow(
                set('roleModalOpen', true),
                set('selectedRole', duplicate),
                set('savedSelectedRole', duplicate)
            )(state);
        }
        case LoginActionTypes.LOGOUT_SUCCESSFUL:
            return INITIAL_STATE;
        default:
            return state;
    }
};
